import type { Task } from "src/queries/tasks/tasks.types";

export const filterOptions = (options: Task[], { inputValue }) =>
  options.filter((option) =>
    option.task_name.toLowerCase().includes(inputValue.toLowerCase())
  );

export const isOptionEqualToValue = (option: Task, value: Task) =>
  option.task_id == value.task_id;

// task comes in the form of a string: "name-id"
export const parseTask = (task?: string): [string, number] | [] => {
  const [name, id] = task?.split(/-(?=[^-]+$)/) ?? [];
  return name && id ? [name, Number(id)] : [];
};
